/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import KTOffcanvas from "../../../_metronic/_assets/js/offcanvas";
import { Badge } from "@mui/material";
import { FormattedMessage } from "react-intl";
import MenuItemsHelper from "../../store/helpers/MenuItemsHelper";


export default class StickyToolbarAIChatBot extends React.Component {
  constructor(props) {
    super(props);

  }
  componentDidMount() {
    // const panel1 = document.getElementById("kt_quick_panel_4");
    // this.offCanvas2 = new KTOffcanvas(panel2, {
    //   overlay: true,
    //   baseClass: "kt-quick-panel",
    //   closeBy: "kt_quick_panel_close_btn_2",
    //   toggleBy: "kt_quick_panel_toggler_btn_2",
    // });
    // this.offCanvas2.on('afterHide', () => { this.updatePanelStatus(2, false); })
    // this.offCanvas2.on('afterShow', () => { this.updatePanelStatus(2, true); })


    // const panel3 = document.getElementById("kt_quick_panel_3");
    // this.offCanvas3 = new KTOffcanvas(panel3, {
    //   overlay: true,
    //   baseClass: "kt-quick-panel",
    //   closeBy: "kt_quick_panel_close_btn_3",
    //   toggleBy: "kt_quick_panel_toggler_btn_3",
    // });
    // this.offCanvas3.on('afterHide', () => { this.updatePanelStatus(3, false); })
    // this.offCanvas3.on('afterShow', () => { this.updatePanelStatus(3, true); })

    const panel1 = document.getElementById("kt_quick_panel_4");
    this.offCanvas1 = new KTOffcanvas(panel1, {
      overlay: false,
      baseClass: "kt-quick-panel",
      closeBy: "kt_quick_panel_close_btn_4",
      toggleBy: "kt_quick_panel_toggler_btn_4",
    });
    this.offCanvas1.on('afterHide', () => { this.updatePanelStatus(1, false); })
    this.offCanvas1.on('afterShow', () => { this.updatePanelStatus(1, true); })

  }

  updatePanelStatus = (panelNum, isOpen) => {
    this.props.onToggle(panelNum, isOpen);
  }

  render() {
    return (
      <>
        <ul className="" >

        </ul>
      </>
    );
  };
}
